import type { SxProps, Theme } from '@mui/material/styles';

type AuditLogStyleMap = {
    root: SxProps<Theme>
    filtersPaper: SxProps<Theme>
    filterDateField: SxProps<Theme>
    filterEntityTypeControl: SxProps<Theme>
    filterTextField: SxProps<Theme>
    filterButton: SxProps<Theme>
    tableContainer: SxProps<Theme>
    tableHeaderRow: SxProps<Theme>
    loadingCell: SxProps<Theme>
    emptyCell: SxProps<Theme>
    dataRow: SxProps<Theme>
    expandCell: SxProps<Theme>
    monoText: SxProps<Theme>
    detailBox: SxProps<Theme>
    detailColumn: SxProps<Theme>
    idRow: SxProps<Theme>
    copyButton: SxProps<Theme>
    loadMoreBox: SxProps<Theme>
    jsonBlock: SxProps<Theme>
};

export const auditLogStyles: AuditLogStyleMap = {
    root: { p: 3 },
    filtersPaper: {
        p: 2,
        mb: 2,
        border: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        alignItems: 'flex-end',
    },
    filterDateField: { width: 160 },
    filterEntityTypeControl: { width: 200 },
    filterTextField: { width: 220 },
    filterButton: { height: 40 },
    tableContainer: { border: '1px solid', borderColor: 'divider' },
    tableHeaderRow: { '& th': { fontWeight: 700, bgcolor: 'grey.50', py: 1.5 } },
    loadingCell: { py: 4 },
    emptyCell: { py: 4, color: 'text.secondary' },
    dataRow: { cursor: 'pointer' },
    expandCell: { py: 0.5 },
    monoText: { fontFamily: 'monospace', fontSize: '0.75rem' },
    detailBox: { p: 2, bgcolor: 'grey.50', display: 'flex', gap: 2, flexWrap: 'wrap' },
    detailColumn: { flex: 1, minWidth: 260 },
    idRow: { display: 'flex', alignItems: 'center', gap: 0.5 },
    copyButton: { p: 0.25, opacity: 0.5, '&:hover': { opacity: 1 } },
    loadMoreBox: { mt: 2, textAlign: 'center' },
    jsonBlock: {
        m: 0,
        p: 1.5,
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        fontSize: '0.75rem',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-all',
        maxHeight: 300,
        overflowY: 'auto',
    },
};
